import React, { createRef, useState } from 'react'
import axios from 'axios'
import { FaFacebook } from "react-icons/fa";
import { FaGithub } from 'react-icons/fa'
import { FaLinkedin } from 'react-icons/fa'
import { FaBuilding } from 'react-icons/fa'
import { IoIosMail } from 'react-icons/io'
import { IoLogoSkype } from 'react-icons/io'
import { IoIosPhonePortrait } from 'react-icons/io'

const Contact = () => {

  const iconStyle = {
    color: '#8282ee', 
    fontSize: '45px',
    cursor: 'pointer'
  }

  const [Error, setError] = useState(false)
  const [alert, setAlert] = useState(null)

  const failure = { text: 'Please fill out all the fields', color: '#4f4fe4' }
  const success = { text: 'Message on the way!', color: 'lightseagreen' }

  const nameRef = createRef()
  const emailRef = createRef()
  const msgRef = createRef()

  const handleSend = e => {
    const name = nameRef.current.value
    const email = emailRef.current.value
    const msg = msgRef.current.value
    if (!name || !email || !msg) {
      setError(true)
      setAlert(failure)
    } else {
      const body = {
        name,
        email,
        msg
      }
      const config = {
        headers: {
          "Content-Type": "application/json"
        }
      }
      setError(true)
      setAlert(success)
      setTimeout(() => {setError(false)}, 3000)
      // axios.post('http://localhost:3001/users/send_msg', body, config).then(res => {
      //   console.log(res.data)
      // })
    }
  }

  return (
    <div>
      <div className='contact'>
        <div className='container'>
          <div class="header"><p>Reach out to me</p></div>
          <div className='box'>
            <div className='left'>
              <div className='icons'>
                <IoIosMail onClick={() => { window.open('mailto:safwan.du16@gmail.com', '_blank') }} style={iconStyle} title='Email: safwan.du16@gmail.com' />
                  <FaFacebook onClick={() => { window.open('https://www.facebook.com/hussain.safwan/', '_blank') }} style={iconStyle} />
                  <FaGithub onClick={() => { window.open('https://github.com/Hussain-Safwan', '_blank') }} style={iconStyle} />
                  <FaLinkedin onClick={() => { window.open('https://www.linkedin.com/in/hussain-md-safwan-649414138/', '_blank') }}  style={iconStyle} />
                  <IoLogoSkype onClick={() => { window.open('https://join.skype.com/invite/Uvk0glSwHJng', '_blank') }} style={iconStyle} />
              </div>
              
            </div>

          { Error ? <div class='alert'><p style={{backgroundColor: alert.color}}>{alert.text}</p></div> : <div></div> }

            <div className='right'>
              <div className='msg-area'>
                <div className='inputs'>
                  <input type='text'  placeholder='Your name' ref={nameRef}/>
                  <input type='text' placeholder='Your email' ref={emailRef}/>
                </div>
                <textarea placeholder='Your precious message' ref={msgRef} />
                <p><button class='blue-btn' onClick={handleSend}>Send</button></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contact